var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5, _react_refresh_temp_6, _react_refresh_temp_7, _react_refresh_temp_8, _react_refresh_temp_9, _react_refresh_temp_10, _react_refresh_temp_11, _react_refresh_temp_12, _react_refresh_temp_13;
var _react_refresh_temp_14;
_react_refresh_temp_14 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { Transition } from '@headlessui/react';
import LeftPanel from '../left-panel';
import RightPanel from '../right-panel';
import MonitorPanel from '../monitor-panel';
import { useAppSelector, store, useAppDispatch } from '../../store';
import ActiveSpeakers from '../active-speakers';
import MainComponents from './mainComponents';
import { updateIsActiveChatPanel } from '../../store/slices/bottomIconsActivitySlice';
import { CurrentConnectionEvents, } from '../../helpers/livekit/types';
const columnCameraWidthSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.columnCameraWidth);
$RefreshReg$(_react_refresh_temp_1, "columnCameraWidthSelector$createSelector");
const columnCameraPositionSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.columnCameraPosition);
$RefreshReg$(_react_refresh_temp_2, "columnCameraPositionSelector$createSelector");
const isActiveParticipantsPanelSelector = createSelector(_react_refresh_temp_3 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveParticipantsPanel);
$RefreshReg$(_react_refresh_temp_3, "isActiveParticipantsPanelSelector$createSelector");
const isActiveMonitorPanelSelector = createSelector(_react_refresh_temp_4 = (state) => state.healthMonitor, (healthMonitor) => healthMonitor.isOpen);
$RefreshReg$(_react_refresh_temp_4, "isActiveMonitorPanelSelector$createSelector");
const isActiveChatPanelSelector = createSelector(_react_refresh_temp_5 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveChatPanel);
$RefreshReg$(_react_refresh_temp_5, "isActiveChatPanelSelector$createSelector");
const activeScreenSharingViewSelector = createSelector(_react_refresh_temp_6 = (state) => state.roomSettings, (roomSettings) => roomSettings.activeScreenSharingView);
$RefreshReg$(_react_refresh_temp_6, "activeScreenSharingViewSelector$createSelector");
const isActiveWhiteboardSelector = createSelector(_react_refresh_temp_7 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveWhiteboard);
$RefreshReg$(_react_refresh_temp_7, "isActiveWhiteboardSelector$createSelector");
const isActiveExternalMediaPlayerSelector = createSelector(_react_refresh_temp_8 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.external_media_player_features;
}, (external_media_player_features) => external_media_player_features === null || external_media_player_features === void 0 ? void 0 : external_media_player_features.is_active);
$RefreshReg$(_react_refresh_temp_8, "isActiveExternalMediaPlayerSelector$createSelector");
const isActiveDisplayExternalLinkSelector = createSelector(_react_refresh_temp_9 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.display_external_link_features;
}, (display_external_link_features) => display_external_link_features === null || display_external_link_features === void 0 ? void 0 : display_external_link_features.is_active);
$RefreshReg$(_react_refresh_temp_9, "isActiveDisplayExternalLinkSelector$createSelector");
const screenHeightSelector = createSelector(_react_refresh_temp_10 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.screenHeight);
$RefreshReg$(_react_refresh_temp_10, "screenHeightSelector$createSelector");
const headerVisibilitySelector = createSelector(_react_refresh_temp_11 = (state) => state.roomSettings, (roomSettings) => roomSettings.visibleHeader);
$RefreshReg$(_react_refresh_temp_11, "headerVisibilitySelector$createSelector");
const footerVisibilitySelector = createSelector(_react_refresh_temp_12 = (state) => state.roomSettings, (roomSettings) => roomSettings.visibleFooter);
$RefreshReg$(_react_refresh_temp_12, "footerVisibilitySelector$createSelector");
const MainArea = ({ isRecorder, currentConnection }) => {
    var _a;
    _react_refresh_temp_14();
    const columnCameraWidth = useAppSelector(columnCameraWidthSelector);
    const columnCameraPosition = useAppSelector(columnCameraPositionSelector);
    const isActiveParticipantsPanel = useAppSelector(isActiveParticipantsPanelSelector);
    const isActiveScreenSharingView = useAppSelector(activeScreenSharingViewSelector);
    const isActiveWhiteboard = useAppSelector(isActiveWhiteboardSelector);
    const isActiveExternalMediaPlayer = useAppSelector(isActiveExternalMediaPlayerSelector);
    const isActiveDisplayExternalLink = useAppSelector(isActiveDisplayExternalLinkSelector);
    const isActiveChatPanel = useAppSelector(isActiveChatPanelSelector);
    const screenHeight = useAppSelector(screenHeightSelector);
    const headerVisible = useAppSelector(headerVisibilitySelector);
    const footerVisible = useAppSelector(footerVisibilitySelector);
    const dispatch = useAppDispatch();
    const [allowChat, setAllowChat] = useState(true);
    const [isActiveScreenShare, setIsActiveScreenShare] = useState(false);
    const [height, setHeight] = useState(screenHeight);
    const assetPath = (_a = window.STATIC_ASSETS_PATH) !== null && _a !== void 0 ? _a : './assets';
    useEffect(() => {
        var _a;
        const metadata = store.getState().session.currentRoom
            .metadata;
        if (!((_a = metadata.room_features) === null || _a === void 0 ? void 0 : _a.chat_features.allow_chat)) {
            setAllowChat(false);
            dispatch(updateIsActiveChatPanel(false));
        }
    }, [dispatch]);
    useEffect(() => {
        setIsActiveScreenShare(currentConnection.screenShareTracksMap.size > 0);
        currentConnection.on(CurrentConnectionEvents.ScreenShareStatus, setIsActiveScreenShare);
        return () => {
            currentConnection.off(CurrentConnectionEvents.ScreenShareStatus, setIsActiveScreenShare);
        };
    }, [currentConnection]);
    const customCSS = useMemo(() => {
        const css = [];
        isActiveChatPanel ? css.push('showChatPanel') : css.push('hideChatPanel');
        isActiveParticipantsPanel
            ? css.push('showParticipantsPanel')
            : css.push('hideParticipantsPanel');
        isActiveScreenSharingView && isActiveScreenShare
            ? css.push('showScreenShare fullWidthMainArea')
            : css.push('hideScreenShare');
        isActiveWhiteboard
            ? css.push('showWhiteboard fullWidthMainArea')
            : css.push('hideWhiteboard');
        isActiveExternalMediaPlayer
            ? css.push('showExternalMediaPlayer fullWidthMainArea')
            : css.push('hideExternalMediaPlayer');
        isActiveDisplayExternalLink
            ? css.push('showDisplayExternalLink fullWidthMainArea')
            : css.push('hideDisplayExternalLink');
        isRecorder ? css.push(`isRecorder`) : null;
        return css.join(' ');
    }, [
        isActiveScreenSharingView,
        isActiveScreenShare,
        isActiveChatPanel,
        isActiveParticipantsPanel,
        isActiveWhiteboard,
        isActiveExternalMediaPlayer,
        isActiveDisplayExternalLink,
        isRecorder,
    ]);
    const renderLeftPanel = useMemo(() => {
        return (_jsx(Transition, { className: "transition-left-panel", show: isActiveParticipantsPanel, unmount: false, enter: "transform transition duration-[400ms]", enterFrom: "opacity-0 translate-x-0", enterTo: "opacity-100", leave: "transform transition duration-[400ms]", leaveFrom: "opacity-100", leaveTo: "opacity-0 -translate-x-full", children: _jsx(LeftPanel, {}) }));
    }, [isActiveParticipantsPanel]);
    const renderMainComponentElms = useMemo(() => {
        return (_jsx(MainComponents, { currentConnection: currentConnection, isActiveWhiteboard: isActiveWhiteboard, isActiveExternalMediaPlayer: isActiveExternalMediaPlayer !== null && isActiveExternalMediaPlayer !== void 0 ? isActiveExternalMediaPlayer : false, isActiveDisplayExternalLink: isActiveDisplayExternalLink !== null && isActiveDisplayExternalLink !== void 0 ? isActiveDisplayExternalLink : false, isActiveScreenSharingView: isActiveScreenSharingView }));
    }, [
        isActiveScreenSharingView,
        currentConnection,
        isActiveDisplayExternalLink,
        isActiveExternalMediaPlayer,
        isActiveWhiteboard,
    ]);
    const renderRightPanel = useMemo(() => {
        if (allowChat) {
            return (_jsx(Transition, { className: "transition-right-panel", show: isActiveChatPanel, unmount: false, enter: "transform transition duration-[400ms]", enterFrom: "opacity-0 translate-x-0", enterTo: "opacity-100", leave: "transform transition duration-[400ms]", leaveFrom: "opacity-100", leaveTo: "opacity-0 translate-x-full", children: _jsx(RightPanel, { currentRoom: currentConnection.room, isRecorder: isRecorder }) }));
        }
        return null;
    }, [currentConnection, isActiveChatPanel]);
    const renderHealthMonitor = useMemo(() => {
        if (!isActiveMonitorPanelSelector) {
            return null;
        }
        return _jsx(MonitorPanel, {});
    }, [currentConnection, isActiveMonitorPanelSelector]);
    useEffect(() => {
        if (isRecorder) {
            setHeight(screenHeight);
            return;
        }
        if (headerVisible && footerVisible) {
            setHeight(screenHeight - 110);
        }
        else if (headerVisible && !footerVisible) {
            setHeight(screenHeight - 50);
        }
        else if (!headerVisible && footerVisible) {
            setHeight(screenHeight - 60);
        }
        else if (!headerVisible && !footerVisible) {
            setHeight(screenHeight);
        }
    }, [screenHeight, isRecorder, headerVisible, footerVisible]);
    return (_jsxs("div", { id: "main-area", className: `plugNmeet-app-main-area overflow-hidden relative flex ${customCSS} column-camera-width-${columnCameraWidth} column-camera-position-${columnCameraPosition}`, style: { height: `${height}px` }, children: [_jsx("div", { className: `main-app-bg absolute w-full h-full left-0 top-0 object-cover pointer-events-none bg-cover bg-center bg-no-repeat`, style: {
                    backgroundImage: `url("${assetPath}/imgs/app-banner.jpg")`,
                } }), _jsxs("div", { className: "inner flex justify-between w-full rtl:flex-row-reverse", children: [renderLeftPanel, _jsxs("div", { className: "middle-area relative flex-auto", children: [_jsx(ActiveSpeakers, {}), renderMainComponentElms] }), renderHealthMonitor, renderRightPanel] })] }));
};
_react_refresh_temp_13 = MainArea;
$RefreshReg$(_react_refresh_temp_13, "MainArea");
_react_refresh_temp_14(MainArea, "hI5gN7dykrl/0TmVBmEj8Wk7Rps=", false, () => [useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppDispatch]);
export default MainArea;
